import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import api from '../api.js';

import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading
const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fSmApiReq = async ({
  sReqUrl,
  methodName,
  sReqJsonStr,
  mchId,
  mallId,
  userId,
  signType = 'TOKEN',
  reqToken,
  sOrgAk,
  sOrgSk,
}) => {
  let reqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let reqJson = Base64.encode(sReqJsonStr);
  let js = {};

  js['METHOD_NAME'] = methodName || '';
  js['REQ_JSON'] = reqJson;
  js['MCH_ID'] = mchId || store.state.smCloud.mch_id;
  js['USER_ID'] = userId || store.state.smCloud.user_id || '1001';
  js['MALL_ID'] = mallId || store.state.smCloud.mall_id || '10011001';
  js['APP_NAME'] = 'djsV8Admin'
  js['REQ_FROM'] = 'WEB';
  js['REQ_VER'] = 'smCloud';
  js['REQ_TIME'] = reqTime;
  js['SIGN_TYPE'] = signType || 'TOKEN';
  js['REQ_LNG'] = store.state.smCloud.lng || 'zh-CN'



  // 组装签名
  if (signType == 'MD5') {
    let sSign
    sSign = sOrgAk + reqJson + reqTime + sOrgSk;
    sSign = md5(sSign);
    sSign = sSign.toLowerCase();
    js['ORG_AK'] = sOrgAk
    js['REQ_SIGN'] = sSign
  } else {
    js['REQ_TOKEN'] = reqToken || store.state.smCloudToken;

  }
  // if (api.smCom.fSmIsEmpty(reqToken || store.state.smCloudToken)) {
  //   window.location.href = 'https://soft.shopzgl.com/smCloud/index.html#/login'
  // }
  try {
    startLoading()
    let res = await axios.post(sReqUrl, js);
    endLoading()
    console.log('Received response:', res.data); // 请求后的日志记录
    if (!isObject(res.data)) {
      return {
        result: 'fail',
        msg: res.data
      }
    }
    if (res.data.result != 'sucess' && res.data.sub_msg == 'tokenFail') {
      setTimeout(() => {
        window.location.href = 'https://soft.shopzgl.com/smCloud/index.html#/login'
      }, 2000)
      return {
        result: 'fail',
        msg: '登录超时 请重新登陆'
      }
    }
    
    return res.data;
  } catch (error) {
    endLoading()
    console.error('Error in API request:', error); // 记录错误日志
    return {
      result: 'fail',
      msg: error.message
    }
    // throw error.message; // 或者返回一个标准的错误对象
  }
  // let res = await axios.post(sReqUrl, js);
  // console.log(res.data)

};
// {"result":"fail","msg":"Cannot create file "D:\smSrv\srv\sys\eLabelTpl\mchTpl\sysTpl-eP2-1-SC-20241228135912397R666.html". 系统找不到指定的路径。","sub_msg":"COPY_LIB"}
function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

//主服务器接口
const fSmCloudAdminApi = async (obj) => {
  console.log(obj, 'fSmCloudAdminApi')
  let sReqUrl;
  sReqUrl = 'https://www.91byk.com/smApi/smSellMain/smCloudAdmin/adminApi'
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
    mallId: obj.mallId || store.state.smCloud.mall_id,
  });
};

const fSmCloudQueryApi = async (obj) => {
  console.log(obj, 'fSmCloudQueryApi')
  // obj.js.DSP_CA = 'WIN'
  let sReqUrl = 'https://www.91byk.com/smApi/smSellMain/smCloudQuery/queryApi';
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk
  });
}
const fDjsAdminApi = async (obj) => {
  console.log(obj, 'fDjsAdminApi')
  let sReqUrl; // = 'http://8.142.32.47/djsAdmin/adminApi'
  if (obj.srv_url) {
    sReqUrl = obj.srv_url + '/djsAdmin/adminApi';
  } else {
    // sReqUrl = 'https://www.91byk.com/smApi/smTest1//djsAdmin/adminApi';
    sReqUrl = store.state.smCloud.load_url + '/djsAdmin/adminApi';
  }
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
    mallId: obj.mallId || store.state.smCloud.mall_id,
  });
}
const fDjsQueryApi = async (obj) => {
  // obj.js.DSP_CA = 'WIN'
  if (!obj.js.DSP_CA) {
    obj.js.DSP_CA = 'SIM'
  }
  let sReqUrl; //= 'http://8.142.32.47/djsQuery/queryApi'
  if (obj.srv_url) {
    sReqUrl = obj.srv_url + '/djsQuery/queryApi';
  } else {
    // sReqUrl = 'https://www.91byk.com/smApi/smTest1/djsQuery/queryApi';
    sReqUrl = store.state.smCloud.load_url + '/djsQuery/queryApi';
  }
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType
  });
}

const fDjsAuditApi = async (obj) => {
  console.log(obj, 'fDjsAdminApi')
  let sReqUrl; // = 'http://8.142.32.47/djsAdmin/adminApi'
  if (obj.srv_url) {
    sReqUrl = obj.srv_url + '/djsAudit/auditApi';
  } else {
    // sReqUrl = 'https://www.91byk.com/smApi/smTest1//djsAdmin/adminApi';
    sReqUrl = store.state.smCloud.load_url + '/djsAudit/auditApi';
  }
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
    mallId: obj.mallId || store.state.smCloud.mall_id,
  });
}

const fSmThirdMainApi = async (obj) => {
  console.log(obj, 'fSmThirdMainApi')
  // obj.js.DSP_CA = 'WIN'
  let sReqUrl = 'https://www.91byk.com/smApi/smThirdMain/smUgv/ugvApi';
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId || store.state.smCloud.org_id,
    userId: obj.userId || store.state.smCloud.user_id,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk
  });
}
export default {
  fSmCloudAdminApi,
  fSmCloudQueryApi,
  fDjsAdminApi,
  fDjsQueryApi,
  fDjsAuditApi,
  fSmThirdMainApi
  
}



//////////////////
// WEBPACK FOOTER
// ./common/api/smCloud.js
// module id = yT98
// module chunks = 16